import {AVAIL_ENDPOINT, AVAIL_ERRORS_ENDPOINT} from '../../helpers/constants';
import {actionTypes} from '../action-types';

export const resetResults = () => dispatch =>
  Promise.resolve(
    dispatch({
      type: actionTypes.RESULTS_STATE_CLEANUP,
    })
  );

export const findAllResults = ({endpoint}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        endpoint,
        searchType: 'all',
      },
      type: actionTypes.RESULTS_LOADING_FRESH_RESULTS,
    })
  );

export const findAvailBySimpleSearchResults = ({endpoint, searchType, valueToFind}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        endpoint,
        searchType,
        params: {
          [searchType]: valueToFind,
        },
      },
      type: actionTypes.RESULTS_LOADING_FRESH_RESULTS,
    })
  );

export const findAvailByPriceTypeAndCurrencyResults = ({params: {price, type, currency}}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        endpoint: AVAIL_ENDPOINT,
        searchType: 'price',
        params: {
          price,
          type,
          currency,
        },
      },
      type: actionTypes.RESULTS_LOADING_FRESH_RESULTS,
    })
  );

export const findErrorsBySystemAndSeverityResults = ({params: {system, severity}}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        endpoint: AVAIL_ERRORS_ENDPOINT,
        searchType: 'systemseverity',
        params: {
          system,
          severity,
        },
      },
      type: actionTypes.RESULTS_LOADING_FRESH_RESULTS,
    })
  );

export const findErrorsByALIDOrEIDRResults = ({searchType, valueToFind}) => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        endpoint: AVAIL_ERRORS_ENDPOINT,
        searchType,
        valueToFind,
        params: {
          [searchType]: valueToFind,
        },
      },
      type: actionTypes.RESULTS_LOADING_FRESH_RESULTS,
    })
  );

export const findIncomingPageResults = incomingPage => dispatch =>
  Promise.resolve(
    dispatch({
      payload: incomingPage,
      type: actionTypes.RESULTS_UPDATING_PAGE,
    })
  );

export const changePageLimitSize = newLimit => dispatch =>
  Promise.resolve(
    dispatch({
      payload: newLimit,
      type: actionTypes.RESULTS_UPDATING_PAGE_LIMIT,
    })
  );

export const handleResultsError = payload => dispatch =>
  Promise.resolve(
    dispatch({
      payload,
      type: actionTypes.RESULTS_EMIT_ERROR,
    })
  );

export const setLoading = payload => dispatch =>
  Promise.resolve(
    dispatch({
      payload,
      type: actionTypes.RESULTS_LOADING,
    })
  );
